import type { ManagementContactGroupMember } from '#pie/internal/api/pie-bff';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultCprManagementContactSorting: DefaultSorting<ManagementContactGroupMember> =
  {
    desc: false,
    id: 'contactGroup.name',
  };

export const cprManagementContactSortingAtom = createSortingAtom({
  defaultSorting: defaultCprManagementContactSorting,
});
